import React from 'react'
import styled from 'styled-components'
import creditCardType from 'credit-card-type'
import Image from '../Image'

import AmericanExpressImg from './../../static/AmericanExpress/amex.png'
import AmericanExpress2XImg from './../../static/AmericanExpress/amex@2x.png'
import AmericanExpress3XImg from './../../static/AmericanExpress/amex@3x.png'
import MasterCardIcon from '../icons/svg/master-card-dark.svg'
import VisaCardIcon from '../icons/svg/Visa-card.svg'

const StyledPaymentIcon = styled.img`
  width: 2.5rem;
`

const CARD_TYPE_VALUES = {
  AmericanExpress: 'AMEX',
  MasterCard: 'MasterCard',
  Visa: 'VISA',
}

const CARD_TYPES = {
  'american-express': CARD_TYPE_VALUES.AmericanExpress,
  mastercard: CARD_TYPE_VALUES.MasterCard,
  visa: CARD_TYPE_VALUES.Visa,
}

const getCreditCardType = number => {
  const cardData = creditCardType(number)[0]
  const cardTypeInLib = cardData !== undefined && cardData.type

  return CARD_TYPES[cardTypeInLib]
}

export const CreditCardType = ({ number, type }) => {
  const cardType = type || getCreditCardType(number)

  switch (cardType) {
    case CARD_TYPE_VALUES.AmericanExpress:
      return (
        <Image
          css={`
            width: 2.5rem;
          `}
          altText="American Express"
          srcSet={`${AmericanExpressImg} 1x, ${AmericanExpress2XImg} 2x, ${AmericanExpress3XImg} 3x`}
          src={AmericanExpressImg}
        />
      )

    case CARD_TYPE_VALUES.MasterCard:
      return <StyledPaymentIcon src={MasterCardIcon} />
    case CARD_TYPE_VALUES.Visa:
      return <StyledPaymentIcon src={VisaCardIcon} />
    default:
      return null
  }
}
